import { get, post, seg } from '../client';
import type { Page } from '../types/common';
import type { CodeSystem, Concept, ConvertUnitsRequest, ConvertUnitsResult, ValidateCodeRequest, ValidateCodeResult, ValueSetExpansion, ValueSetSummary } from '../types/terminology';

export const terminologyApi = {
  codeSystems: () => get<Page<CodeSystem>>('/terminology/code-systems', { limit: 100 }),
  lookup: (system: string, code: string) => get<Concept>('/terminology/lookup', { system, code }),
  search: (system: string, q: string, limit = 25) => get<Page<Concept>>('/terminology/search', { system, q, limit }),
  validateCode: (body: ValidateCodeRequest) => post<ValidateCodeResult>('/terminology/validate-code', body),
  /** Value sets available for validation/expansion (UUID ids on core-api). */
  valueSets: (p: { limit?: number; cursor?: string } = {}) => get<Page<ValueSetSummary>>('/terminology/value-sets', { limit: 100, ...p }),
  expand: (valueSetId: string, filter?: string) => get<ValueSetExpansion>(`/terminology/value-sets/${seg(valueSetId)}/expand`, { filter }),
  convertUnits: (body: ConvertUnitsRequest) => post<ConvertUnitsResult>('/terminology/convert-units', body),
};
